const C = {
  name: "Cloud",
  dimensions: { width: 40, height: 41 },
  content: `
    <svg fill="currentColor">
    <g clip-path="url(#clip0_12_4496)">
    <path d="M25 0.00292969C21.28 0.00292969 18.04 2.04293 16.32 5.05293C15.2 4.39293 13.9 4.00293 12.5 4.00293C8.36 4.00293 5 7.36293 5 11.5029C5 12.8329 5.35 14.0829 5.96 15.1629C2.56 15.8729 0 18.8929 0 22.5029C0 26.4729 3.09 29.7229 7 29.9729V30.0029H30C35.52 30.0029 40 25.5229 40 20.0029C40 16.2629 37.95 13.0129 34.91 11.2929C34.96 10.8729 35 10.4429 35 10.0029C35 4.48293 30.52 0.00292969 25 0.00292969ZM25 2.00293C29.41 2.00293 33 5.59293 33 10.0029C33 10.3029 32.98 10.6329 32.92 11.0429L32.75 12.3829L33.92 13.0429C36.44 14.4529 38 17.1229 38 20.0029C38 24.4129 34.41 28.0029 30 28.0029H7.45L7.13 27.9829C4.25 27.7929 2 25.3829 2 22.5029C2 19.9129 3.84 17.6529 6.37 17.1229L9.04 16.5629L7.7 14.1829C7.24 13.3629 7 12.4429 7 11.5029C7 8.47293 9.47 6.00293 12.5 6.00293C13.48 6.00293 14.44 6.27293 15.3 6.77293L17.05 7.81293L18.06 6.04293C19.48 3.55293 22.14 2.00293 25 2.00293Z" />
    </g>
    <defs>
    <clipPath id="clip0_12_4496">
    <rect width="40" height="30" fill="currentColor" transform="translate(0 0.00292969)"/>
    </clipPath>
    </defs>
    </svg>
  `
};
export {
  C as Cloud
};
